var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225.2 222.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e9e9ea;\n      }\n\n      .cls-2 {\n        fill: #f8d164;\n      }\n\n      .cls-3 {\n        fill: #dcddde;\n      }\n\n      .cls-4 {\n        fill: #f1f2f2;\n      }\n\n      .cls-5 {\n        fill: #c08e2c;\n        isolation: isolate;\n        opacity: .7;\n      }\n\n      .cls-6 {\n        fill: #e1ad3b;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #dedfe0;\n      }\n\n      .cls-9 {\n        fill: #cdcfd0;\n      }\n\n      .cls-10 {\n        fill: #dadbdc;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M146.57,11.33s27.09,9.93,39.78,20.71c12.69,10.77,28.96,26.51,34.87,44.68s5.99,44.95-4.9,67.84c-7.06,14.82-25.06,35.96-35.96,47.95-11.54,12.69-27.47,21.41-44.41,25.88-23.7,6.27-47.13,5.18-65.93-2.45-17.88-7.26-44.03-23.04-57.48-46.22C-.55,147.19.45,122.85.45,122.85l76.78,77.87,83.92-19.86,42.46-49.91s-42.61-89.6-43.48-90.48c-8.47-8.6-14.38-21.78-14.38-21.78l.82-7.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M134.31,7.79c-10.63-3.27-17.71-3.95-27.52-3.27s-17.84,1.63-30.38,6.81c9.43-2.36,15.44-.94,28.03-1.12,11.87-.17,27.12,5.41,29.86-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M217.4,98.24c1.36,33.51-12.26,49.86-25.34,66.47s-32.4,41.51-70.29,47.68c-35.14,5.72-65.57-5.76-87.45-24.52C11.44,168.26,3.27,149.68.54,126.57s5.34-44.01,13.08-59.66c6.46-13.08,11.89-22.62,23.97-34.6,10.35-10.26,26.15-17.35,38.14-20.98,11-3.33,44.41-10.35,81.83,9.73,32.42,17.39,58.25,38.25,59.83,77.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.26,25.26c.74,2.68-3.79,5.66-10.74,10.15-8.21,5.3-16.29,12.89-24,24.03-6.79,10.56-10,16.06-14.38,15.17s.02-10.07,5.9-19.69c6.21-10.14,12.78-17.62,27.98-26.55,10.4-6.11,14.5-5.78,15.25-3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M72.36,24.24c.49,1.54-3.39,3.87-10.65,8.4-8.9,5.56-17.38,13.68-23.82,22.73-7.91,11.8-9.82,17.77-12.75,16.88-3.98-1.21.91-10.54,6.63-19.72,6.02-9.67,11.12-16.46,19.81-22.45,8.69-5.99,19.64-9.42,20.79-5.85h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 20.87,
    cy: 87.77,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 18.3,
    cy: 86.83,
    r: 5.09
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 109.47,
    cy: 204.45,
    r: 14.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 106.34,
    cy: 201.98,
    r: 10.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 104.37,
    cy: 200.61,
    r: 5.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 139.93,
    cy: 193.29,
    r: 9.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 137.8,
    cy: 191.61,
    r: 7.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 136.43,
    cy: 189.98,
    r: 4.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 49.26,
    cy: 179.35,
    r: 10.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.69,
    cy: 176.85,
    r: 8.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 46.62,
    cy: 174.83,
    r: 4.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 209.52,
    cy: 85.88,
    r: 11.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 206.53,
    cy: 84.52,
    r: 9.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 204.31,
    cy: 83.89,
    r: 4.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 105.43,
    cy: 104.13,
    r: 66.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 111.43,
    cy: 110.13,
    r: 66.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.2,57.04c11.74,12.01,18.99,28.43,18.99,46.55,0,36.77-29.81,66.58-66.58,66.58-17.14,0-32.76-6.48-44.56-17.11,12.28,14.68,30.73,24.02,51.37,24.02,36.98,0,66.95-29.97,66.95-66.95,0-21.63-10.26-40.85-26.18-53.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.44,107.36c-12.49,12.49-32.95,12.91-41.56,5.72-10.12-8.45-9.44-30.37,1.43-44.29,10.6-13.57,30.48-17.98,43.46-5.72,12.98,12.26,9.53,31.43-3.33,44.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M160.76,109.31c-.26-2.9-2.37-5.39-5.45-6.93-1.14-.57-10.9-6.49-18.22-10.48-7.33-3.99-29.62-17.77-31.73-18.99-3-1.84-10.66-6.61-11.84-7.34-.52-.32-1.34-.87-2.33-1.23-2.23-1.32-5.8-.98-7.43.05-2.33,1.47-3.36,4.74-3.12,8.38.09,1.35.11,13.89.14,22.75s-.09,36.1-.07,38.56c.02,3.23.07,13.46.04,14.94-.03,1.47-.27,5.04,2.69,6.71,1.24.7,2.53,1.08,3.74,1.13.63.11,1.31.09,2.03-.08,2.23-.52,8.71-5.41,15.54-9.23,9.26-5.18,22.92-13.38,29.83-17.44,5.72-3.36,12.76-7.27,16.57-9.44,1.81-.96,4.46-2.4,6.67-3.95s3.18-4.7,2.94-7.41h0ZM131.8,117.67c-7.03,4.57-31.19,17.54-33.18,18.74-1.21.73-2.66,1.4-5.04,2.83.36-11.29.54-23.16.54-32.01,0-7.72.32-19.78.14-25.97,6.54,3.9,21.1,12.19,27.11,15.76s18.34,10.7,22.32,13.32c-3.64,2.2-8,4.81-11.89,7.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M160.77,109.31h0c-.26-2.9-2.37-5.39-5.45-6.93-1.14-.57-10.9-6.49-18.22-10.48-3.36-1.83-9.87-5.72-16.14-9.52-.07,4.23-1.09,8.54-2.94,12.66,1.28.74,2.43,1.42,3.36,1.97,6.01,3.56,18.34,10.7,22.32,13.32-3.64,2.2-8,4.81-11.89,7.33-7.03,4.57-31.19,17.54-33.18,18.74-1.21.73-2.66,1.4-5.04,2.83.25-7.77.41-15.82.49-22.97-4.52,1.3-9.12,1.73-13.33,1.39-.02,8.04-.04,15.21-.03,16.42.02,3.23.07,13.46.04,14.94-.03,1.47-.27,5.04,2.69,6.71,1.24.7,2.53,1.08,3.74,1.13.63.11,1.31.09,2.03-.08,2.23-.52,8.71-5.41,15.54-9.23,9.26-5.18,22.92-13.38,29.83-17.44,5.72-3.36,12.76-7.27,16.57-9.44,1.81-.96,4.46-2.4,6.67-3.95,2.21-1.55,3.18-4.7,2.94-7.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 134.4,
    cy: 14.21,
    rx: 14.54,
    ry: 14.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 132.25,
    cy: 15.67,
    r: 12.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 131.17,
    cy: 15.89,
    r: 6.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 129.2,
    cy: 14.81,
    r: 5.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.c74b351f1040ffcde94cce07975dfd39.svg";
export { ForwardRef as ReactComponent };